import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Alert from "./Alert";
import { setShowToast } from "../../redux/slice/rfpModuleSlice/application";
import { RootState } from "redux/store";

const validAlertTypes = [
  "success",
  "error",
  "warning",
  "info",
  "primary",
] as const;
type AlertType = (typeof validAlertTypes)[number];

const Toast: React.FC = () => {
  const dispatch = useDispatch();
  const { showToast, toastMessage, type, toastDuration = 2000 } = useSelector(
    (state: RootState) => state.applicationData
  );

  const alertType: AlertType = validAlertTypes.includes(type as AlertType)
    ? (type as AlertType)
    : "info";

  useEffect(() => {
    if (showToast) {
      const timer = setTimeout(() => {
        dispatch(setShowToast({ show: false, toastMessage: "", toastDuration }));
      }, toastDuration);

      return () => clearTimeout(timer);
    }
  }, [showToast, dispatch]);

  if (!showToast) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: "30px",
        right: "30px",
        zIndex: 9999,
      }}
    >
      <Alert
        icon
        type={alertType}
        title=""
        description={toastMessage}
        theme="light"
        dismissible
        onClose={() =>
          dispatch(setShowToast({ show: false, toastMessage: "" }))
        }
      />
    </div>
  );
};

export default Toast;
